module.exports = "<div #dataR></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/policy/policy.component.html
// module id = ./src/app/policy/policy.component.html
// module chunks = main